import { render, staticRenderFns } from "./DoctorenlineaLegal.vue?vue&type=template&id=34deb0ed&scoped=true"
import script from "./DoctorenlineaLegal.vue?vue&type=script&lang=js"
export * from "./DoctorenlineaLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34deb0ed",
  null
  
)

export default component.exports